import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import DetectorController, { HotelListType } from '../../controller/DetectorController';
import StoreController from '../../controller/StoreController';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

type addressType = {
  bcode: string;
  name: string;
};

interface InputAddressProps {
  selectedHotel: HotelListType | null;
  selectedList: addressType[];
  setSelectedList: (selectedList: addressType[]) => void;
}

const RenderInputAddress = ({
  selectedHotel,
  selectedList,
  setSelectedList,
}: InputAddressProps) => {
  const [keyword, setKeyword] = useState<string>('');
  const [searchedList, setSearchedList] = useState<addressType[]>([]);

  const getBcodeList = async () => {
    if (keyword.length > 1) {
      const oParams = {
        name: keyword,
      };
      const oResponse = await StoreController.getBcodeList(oParams);
      if (oResponse && oResponse.data) {
        setSearchedList([...oResponse.data]);
      }
    }
  };

  const handleCheckboxClick = (item: addressType) => {
    if (selectedList.find((option: addressType) => option.bcode === item.bcode)) {
      setSelectedList([...selectedList.filter((option) => option.bcode !== item.bcode)]);
    } else {
      setSelectedList([...selectedList, item]);
    }
  };

  const checkAllListItem = () => {
    // console.log('selectedList', selectedList, searchedList);
    if (searchedList.every((item) => selectedList.includes(item))) {
      setSelectedList(
        selectedList.filter((item) => !searchedList.some((searchedItem) => searchedItem === item)),
      );
    } else {
      setSelectedList(
        Array.from([
          ...searchedList,
          ...selectedList.filter(
            (item) => !searchedList.some((searchedItem) => searchedItem.bcode === item.bcode),
          ),
        ]),
      );
    }
  };

  useEffect(() => {
    setKeyword('');
    setSearchedList([]);
  }, [selectedHotel]);

  return (
    <div className="inputArea">
      <h3 className="title">배달구역 추가</h3>
      <div className="inputWrap">
        <input
          value={keyword}
          placeholder="주소를 입력해주세요 (최소 2자 이상)"
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              getBcodeList();
            }
          }}
        />
        <button onClick={getBcodeList}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
        </button>
      </div>
      <div className="between">
        <h3 className="title">검색 결과</h3>
        <label htmlFor="all_item" className="all">
          <h5>목록 모두 선택</h5>
          <input
            id="all_item"
            type="checkbox"
            autoFocus={false}
            checked={
              searchedList.length > 0 && searchedList.every((item) => selectedList.includes(item))
            }
            onChange={checkAllListItem}
          />
        </label>
      </div>
      <div className="resultBox">
        {searchedList.length > 0 ? (
          searchedList.map((item, index) => (
            <label key={index} htmlFor={`check_${index}`} className="resultItem">
              <h4>{item.name}</h4>
              <input
                id={`check_${index}`}
                type="checkbox"
                autoFocus={false}
                checked={selectedList.filter((option) => option.bcode === item.bcode).length > 0}
                onChange={() => handleCheckboxClick(item)}
              />
            </label>
          ))
        ) : (
          <h2>검색 결과가 없어요</h2>
        )}
      </div>
    </div>
  );
};

interface CheckedAddressProps {
  selectedHotel: HotelListType | null;
  selectedList: addressType[];
  setSelectedList: (selectedList: addressType[]) => void;
  addressList: addressType[];
}

const RenderCheckedAddress = ({
  selectedHotel,
  selectedList,
  setSelectedList,
  addressList,
}: CheckedAddressProps) => {
  const [keyword, setKeyword] = useState<string>('');
  const [searchedList, setSearchedList] = useState<addressType[]>([]);

  const getSearchResult = () => {
    setSearchedList(addressList.filter((item) => item.name.includes(keyword)));
  };

  const deleteItem = (item: addressType) => {
    if (selectedList.find((option: addressType) => option.bcode === item.bcode)) {
      console.log('delete');
      setSelectedList([...selectedList.filter((option) => option.bcode !== item.bcode)]);
      setSearchedList(
        [...selectedList.filter((option) => option.bcode !== item.bcode)].filter((item) =>
          item.name.includes(keyword),
        ),
      );
    }
  };

  useEffect(() => {
    setKeyword('');
    if (addressList) {
      console.log('addressList', addressList);
      setSearchedList([...addressList]);
    }
  }, [selectedHotel, addressList]);

  useEffect(() => {
    console.log('searchedList', searchedList);
  }, [searchedList]);

  return (
    <div className="inputArea">
      <h3 className="title">등록된 배달구역</h3>
      <div className="inputWrap">
        <input
          value={keyword}
          placeholder="주소를 입력해주세요 (최소 2자 이상)"
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              getSearchResult();
            }
          }}
        />
        <button onClick={getSearchResult}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
        </button>
      </div>
      <h3 className="title">검색 결과</h3>
      <div className="resultBox">
        {searchedList.length > 0 ? (
          searchedList.map((item, index) => (
            <div key={index} className="resultItem">
              <h4>{item.name}</h4>
              <button className="deleteButton" onClick={() => deleteItem(item)}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan_white.svg`} alt="delete" />
              </button>
            </div>
          ))
        ) : (
          <h2>검색 결과가 없어요</h2>
        )}
      </div>
    </div>
  );
};

const HotelDeliveryArea = () => {
  const navigate = useNavigate();
  const [hotelList, setHotelList] = useState<HotelListType[]>([]);
  const [selectedHotel, setSelectedHotel] = useState<HotelListType | null>(null);
  const [addressList, setAddressList] = useState<addressType[]>([]);
  const [selectedList, setSelectedList] = useState<addressType[]>([]);

  // API 호출
  const getHotelList = async () => {
    try {
      const response = await DetectorController.getHotelList();

      if (response && response.data) {
        const formattedHotelList = response.data.data.map((item: any) => ({
          value: item.store_name,
          label: item.store_name,
          store_id: item.store_id,
          user_id: item.user_id,
          bcode_list: item.bcode_list,
        }));
        setHotelList(formattedHotelList);
        if (selectedHotel === null) {
          setSelectedHotel(formattedHotelList[0] || null);
          setAddressList(formattedHotelList[0].bcode_list || null);
          setSelectedList(formattedHotelList[0].bcode_list || null);
        } else {
          const bcodeList = formattedHotelList.find(
            (item: HotelListType) => item.store_id === selectedHotel.store_id,
          );
          console.log('bcodeList');
          if (bcodeList) {
            setAddressList([...bcodeList.bcode_list]);
            setSelectedList([...bcodeList.bcode_list]);
          }
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const setHotelBcode = async () => {
    try {
      const bcodeListTemp = selectedList.map((item) => {
        return item.bcode;
      });
      const oParams = {
        store_id: selectedHotel?.store_id,
        bcode_list: bcodeListTemp,
      };

      const response = await StoreController.setHotelBcode(oParams);

      if (response && response.data) {
        const resData = response.data.data;
        if (resData) {
          toast.success('배달구역을 변경했어요');
          getHotelList();
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const handleChange = (selectedOption: HotelListType | null) => {
    setSelectedHotel(selectedOption);
    if (selectedOption) {
      setSelectedList([...selectedOption.bcode_list]);
      setAddressList([...selectedOption.bcode_list]);
    }
  };
  useEffect(() => {
    getHotelList();
  }, []);

  return (
    <Style>
      <div className="wrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h1>호텔 배달구역 설정</h1>
        <div className="header">
          <div className="selectWrap">
            <Select options={hotelList} value={selectedHotel} onChange={handleChange} />
          </div>
        </div>
        <div className="content">
          <RenderInputAddress
            selectedHotel={selectedHotel}
            selectedList={selectedList}
            setSelectedList={setSelectedList}
          />
          <RenderCheckedAddress
            selectedHotel={selectedHotel}
            addressList={addressList}
            selectedList={selectedList}
            setSelectedList={setSelectedList}
          />
          {/* <h3 className="title">등록된 배달구역</h3>
          <div className="resultBox selected">
            {selectedList.length > 0 ? (
              selectedList.map((item, index) => (
                <div key={index} className="resultItem">
                  <h4>{item.name}</h4>
                  <button className="deleteButton" onClick={() => deleteItem(item)}>
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan_white.svg`} alt="delete" />
                  </button>
                </div>
              ))
            ) : (
              <h2>등록된 배달구역이 없어요</h2>
            )}
          </div> */}
        </div>
        <button className="confirmButton" onClick={setHotelBcode}>
          저장
        </button>
      </div>
    </Style>
  );
};

export default HotelDeliveryArea;

const Style = styled.div`
  /* font설정 */
  h1 {
    font-size: 24px;
    margin-bottom: 6px;
  }
  h2 {
    font-size: 20px;
    line-height: 36px;
    font-weight: 500;
  }
  h3 {
    font-size: 18px;
    line-height: 32px;
    font-weight: 500;
  }
  h4 {
    margin: 6px 0;
    font-size: 14px;
    font-weight: 400;
    color: #777777;
    white-space: normal;
  }

  h3.title {
    padding-top: 20px;
  }

  .between {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    .all {
      display: flex;
      gap: 4px;
      padding: 10px 0;
      h5 {
        font-size: 12px;
        font-weight: 500;
        color: #555;
      }
    }

    input[type='checkbox'] {
      accent-color: #40977f;
      width: 14px;
      height: 14px;
      vertical-align: middle;
    }
  }

  /* wrap */
  .wrap {
    width: 100%;
    max-width: 100%;
    padding: 30px 2vw;
  }

  /* header */
  .header {
    display: flex;
    justify-content: space-between;

    .selectWrap {
      padding-top: 20px;
      width: 20%;
    }
  }
  .content {
    width: 70%;
    display: flex;
    gap: 20px;
    padding: 10px 0;
  }

  .inputArea {
    flex: 1;
    padding-bottom: 30px;

    .inputWrap {
      display: flex;
      align-items: center;

      input {
        flex: 1;
        border: 1px solid #aaa;
        border-radius: 5px;
        padding: 6px 10px;
        font-size: 16px;
        line-height: 24px;
        color: #555;
      }
      input:focus {
        outline-color: #4dd2ae;
      }
      input::placeholder {
        color: #cccccc;
      }

      button {
        margin-left: -8px;
        height: 38px;
        border-radius: 5px;
        padding: 0 20px;
        background: #4dd2ae;
        border: none;
      }
    }
  }

  .resultBox {
    width: 100%;
    height: 40dvh;
    border: 1px solid #aaa;
    border-radius: 5px;
    overflow-y: auto;
    .resultItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 20px;
      border-bottom: 1px solid #efefef;
    }
    h2 {
      padding: 10px;
      margin: auto 0;
      color: #555;
    }
    input[type='checkbox'] {
      accent-color: #40977f;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
  .resultBox.selected {
    width: 70%;
  }

  .deleteButton {
    display: flex;
    align-items: center;
    padding: 6px 10px;
    margin: 4px 0;
    border: none;
    background: #ff6060;
    border-radius: 3px;
  }

  .confirmButton {
    width: 70%;
    padding: 10px;
    font-size: 18px;
    line-height: 24px;
    border-radius: 5px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 0;
    color: #fff;
    background: #4dd2ae;
    border: 1px solid #4dd2ae;
  }

  @media (max-width: 800px) {
    h2 {
      font-size: 16px;
    }
    h3 {
      font-size: 18px;
    }
    h4 {
      margin: 4px 0;
    }

    .header {
      flex-direction: column;
      .selectWrap {
        width: 100%;
        margin-bottom: 18px;
      }
    }
    .inputArea {
      width: 100%;
      .inputWrap {
        input {
          font-size: 14px;
          line-height: 20px;
        }
        button {
          height: 34px;
          border-radius: 3px;
          padding: 0 12px;
        }
      }
    }
    .resultBox.selected {
      width: 100%;
    }
    .confirmButton {
      width: 100%;
    }
    .content {
      width: 100%;
      gap: 10px;
      flex-direction: column;
    }

    .resultBox {
      height: 30dvh;
      .resultItem {
        padding: 4px 12px;
      }
      h2 {
        padding: 4px 10px;
      }
    }
  }
`;
